export var EMPTY_CTN = 'empty_ctn';
export var IS_NOT_CHECKED_AGREEMENT = 'is_not_checked_agreement';